import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Grid,
    IconButton,
    Radio,
    RadioGroup,
    styled,
    Typography
} from "@mui/material";
import React from "react";
import {HighlightOff} from "@mui/icons-material";
import { DialogHeader } from '../../../../../../theme';

// region TypeScript Interfaces
interface ShareDialogState {
    shareLevel: 'company' | 'partner' | string;
    [key: string]: unknown;
}

interface EnhancedShareDialogProps {
    isRetailer?: boolean;
    open: boolean;
    onClose: (event?: unknown, reason?: string) => void;
    disabled?: boolean;
    state: ShareDialogState;
    setState: (patch: Partial<ShareDialogState>) => void;
    share: () => void;
}
// endregion

const StyledRadio = styled(Radio)(({theme}) => ({
    '&, &.Mui-checked': {
        // TODO(ENG-344): tertiary is a custom palette key declared in src/theme.js;
        // remove cast once theme is migrated to TS with module augmentation.
        color: (theme.palette as any).tertiary.main,
        filter: "brightness(150%)"
    }
}));

export default function EnhancedShareDialog(props: EnhancedShareDialogProps) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {isRetailer, open, onClose, disabled, state, setState, share} = props; // These vars are used

    return (
        <Dialog
            open={open}
            onClose={(event, reason) => {
              if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                if (disabled) return;
              }
              onClose(event, reason);
            }}
            maxWidth='sm'
            fullWidth={true}
            slotProps={{
                paper: {
                    style: {
                        borderRadius: "12px"
                    }
                }
            }}>
            <DialogTitle>
                <Grid item container justifyContent={"space-between"} alignItems={"center"}>
                    <Grid item container style={{flex: 0.5, flexDirection: "column"}}>
                        <DialogHeader>
                            Share Export Profile
                        </DialogHeader>
                    </Grid>

                    <IconButton onClick={() => props.onClose()} size="large">
                        <HighlightOff style={{color: "red"}}/>
                    </IconButton>
                </Grid>
            </DialogTitle>
            {isRetailer ? (
                    <>
                        <DialogContent>
                            <Typography style={{fontSize: "16px"}}>
                                Who should be allowed to access this profile?
                            </Typography>
                            <RadioGroup {...({disabled} as any)} value={props.state.shareLevel}
                                        onChange={(e) => props.setState({shareLevel: e.target.value})}>
                                <FormControlLabel value={'company'} control={<StyledRadio/>}
                                                  label='All users from my company.'/>
                                <FormControlLabel value={'partner'} control={<StyledRadio/>}
                                                  label='All users from my company and all trading partners. Trading partners will not be able to change the profile.'/>
                            </RadioGroup>
                        </DialogContent>
                        <DialogActions style={{padding: "24px"}}>
                            <Button variant="text" disabled={disabled} onClick={onClose}>Cancel</Button>
                            <Button variant="text" color="primary" disabled={disabled} onClick={props.share}>Share</Button>
                        </DialogActions>
                    </>
                )
                : (
                    <>
                        <DialogContent>
                            <Typography style={{fontSize: "16px"}}>
                                Do you want to share this profile with other users at your company?
                            </Typography>
                        </DialogContent>
                        <DialogActions style={{padding: "24px"}}>
                            <Button variant="text" disabled={disabled} onClick={onClose}>No</Button>
                            <Button variant="text" color="primary" disabled={disabled} onClick={props.share}>Yes</Button>
                        </DialogActions>
                    </>
                )}
        </Dialog>
    );
}
